export default () => ({
	price: '',
	available: true,
	disabled: false,

	init() {
		this.variantData = JSON.parse(this.$el.querySelector('script[type="application/json"]').textContent)

		this.updateCurrentVariant();

		this.disabled = this.currentVariant && !this.currentVariant.available;
		this.available = this.currentVariant && this.currentVariant.available;
	},

	onChange() {
		this.updateCurrentVariant();

		if (this.currentVariant) {
			// Update URL
			window.history.replaceState({}, '', `${document.location.pathname}?variant=${this.currentVariant.id}`);

			// Update master input
			this.$el.querySelectorAll('[name="id"]').forEach((input) => {
				input.value = this.currentVariant.id;
			});
		}

		this.disabled = this.currentVariant && !this.currentVariant.available;
		this.available = this.currentVariant && this.currentVariant.available;
	},

	updateCurrentVariant() {
		// Get selected options
		let options = Array.from(this.$el.querySelectorAll('select'), (select) => select.value);

		// Find the variant that corresponds to the selected options
		this.currentVariant = this.getVariantData().find((variant) => {
			return !variant.options.map((option, index) => {
				return options[index] === option;
			}).includes(false);
		});

		if (this.currentVariant) {
			this.price = `$${(this.currentVariant.price / 100).toFixed(2)}`;
		}
	},

	getVariantData() {
		this.variantData = this.variantData || JSON.parse(this.$el.querySelector('[type="application/json"]').textContent);
		return this.variantData;
	},
})
